<template>
  <div>
    <v-breadcrumbs :items="breadcrumbItems"/>

    <v-card  v-if="event">
      <Header :event="event"/>
      <v-container>
      <v-row>
        <v-col cols="12" md="7">
          <EventTimelineCard :event="event" ref="timeline" />
        </v-col>
        <v-col cols="12" md="5">
          <InsightsSummary ref="insights" />
        </v-col>
      </v-row>
      </v-container>
      <v-card-title class="headline">Insights for {{event.name}}</v-card-title>

      <v-card-text>      
        <p>
          Key metrics are calculated weekly, based on Monday - Sunday weeks. 
          Note that insights are always at least one day behind. 
        </p>
        <p>
          Insights are calculated based on standardized metrics, allowing a consistent measurement across events and comparison with industry standards (coming soon).
        </p>
      </v-card-text>

      <v-alert v-if="!eventUtil.isProPlan()" type="info" tile>
        <div class="d-flex flex-row align-content-center">
          <p class="grow mb-0"><router-link class="white--text" :to="{name: 'eventmanagerLicense', params: {id:event.id}}">Upgrade to a PRO plan</router-link> to access insights.</p>
          <v-btn class="shrink white--text" :to="{name: 'eventmanagerLicense', params: {id:event.id}}">Upgrade</v-btn>
        </div>
      </v-alert>

      <InsightsOverview ref="insightsOverview" />

    </v-card>
  </div>      
</template>

<script>
import { mapGetters } from "vuex";
import eventManagerService from "@/services/eventManagerService";
import { EventBus } from '@/plugins/eventbus.js';
import { DateTime } from 'luxon'
import siteData from '@/data/site.json'
import Header from './_Header.vue'
import EventUtil from "@/util/eventUtil";
import EventTimelineCard from '@/views/eventmanager/_EventTimelineCard.vue';
import InsightsSummary from '@/components/eventmanager/InsightsSummary.vue';
import InsightsOverview from '@/components/eventmanager/InsightsOverview.vue';
import SimpleTooltip from '@/components/SimpleTooltip.vue';

export default {
  name: "Insights",
  components: {
    Header,
    SimpleTooltip,
    InsightsSummary,
    InsightsOverview,
    EventTimelineCard,
  },
  data() {
    return {
      event: null,
      provider: null,
      model: {},
      stats: null,
      insights: null,
      snapshot: null,
      siteData: siteData,
      races: [],
      showPeriodDialog: false,
      engagementScoreExpanded: false,
      activityScoreExpanded: false,
      moveScoreExpanded: false,
      headers: [
        { text: 'Name', sortable: true, value: 'name',},
        { text: 'Participants', sortable: true, value: 'participants',},
        { text: 'Results', sortable: true, value: 'results',},
        { text: 'Completed', sortable: true, value: 'completed',},
        { text: 'Actions', value: 'actions', sortable: false },
      ],

    };
  },
  async mounted() {
    await this.getProfile();
    
    EventBus.$on('login-state-change', async user => {
      await this.getProfile();
    });
  },
  methods: {
    async getEvent(id) {
      this.event = (await eventManagerService.get(id)).data;
      this.stats = (await eventManagerService.getStats(id)).data;
      await this.getInsights();
    },
    async getInsights(date) {
      //this.insights = (await eventManagerService.getInsights(this.event.id, date || this.$route.query.date)).data;
      //this.snapshot = this.insights.latest;
      //console.log('STATS snapshots', this.insights);
      this.$refs.insights.loadForEvent(this.event);
      this.$refs.insightsOverview.loadForEvent(this.event);
    },
    async getProfile() {
      if (this.user) {
        await this.getEvent(this.$route.params.id);
      }
    },
    async downloadReport(reportName, filename) {
      var fromDate = DateTime.fromISO(this.snapshot.from, { zone: this.event.timezone }).startOf('day').toISODate();
      var tillDate = DateTime.fromISO(this.snapshot.till, { zone: this.event.timezone }).startOf('day').toISODate();
      console.log('/// date', fromDate, tillDate);

      try{
        const response = await eventManagerService.exportReport(this.event.id, reportName, /*group:*/null, fromDate, tillDate);
        this.downloadReportData(response, `${filename}-${this.snapshot.period_type}-${this.snapshot.period}`);
      }
      catch {
        this.$helpers.toastResponse(this, { status: "ERROR", msg: "No permissions to view report."});
      }
    },
    async downloadReportData(response, filename) {
      console.log('// report response', response);
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename.replace(".", "_")
        link.click()
        URL.revokeObjectURL(link.href)
    },
    // getStatsForRace(raceId) {
    //   return this.stats && this.stats.participants_by_race && this.stats.participants_by_race[raceId];
    // },

  },
  computed: {
    breadcrumbItems() {
      return !this.event ? [] : [
        { text: 'Event Manager', exact: true, to: { name: 'eventmanager' } },
        { text: this.event.name, exact: true, to: { name: 'eventmanagerView', params: {id: this.event.id}} },
        { text: `Insights`, disabled: true },
      ];
    },
    eventUtil() {
      return new EventUtil(this, this.event);
    },
    reportsAvailable() {
      return this.eventUtil.isProPlan();
    },

    
    ...mapGetters({
      user: "user"
    })
  },
};
</script>
<style lang="scss">
</style>

